var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPedestrian = function SvgPedestrian(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-walking-5026477 1",
    clipPath: "url(#clip0_1260_18833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.06829 5.1068C8.0865 5.1068 8.91198 4.28136 8.91198 3.26312C8.91198 2.24488 8.0865 1.41943 7.06829 1.41943C6.05003 1.41943 5.22461 2.24488 5.22461 3.26312C5.22461 4.28136 6.05003 5.1068 7.06829 5.1068Z",
    stroke: "#2E3744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.93622 6.88217C2.77729 6.97066 2.64564 7.10107 2.55565 7.2592L1.04321 9.91632C0.791369 10.3587 0.945882 10.9216 1.38833 11.1734C1.8308 11.4253 2.39366 11.2708 2.64549 10.8283L4.03026 8.39503C4.03702 8.38317 4.04686 8.3734 4.05878 8.36683L4.26705 8.2508L3.91135 9.57831C3.73036 10.254 3.94908 10.9425 4.42266 11.3929L6.39288 13.3628L7.30889 16.7392C7.44219 17.2306 7.94859 17.5208 8.43999 17.3875C8.93133 17.2542 9.22153 16.7479 9.08823 16.2565L8.13861 12.7569C8.07629 12.5272 7.95492 12.3178 7.78665 12.1495L7.19765 11.5605L7.86697 9.06282L8.36126 9.95559C8.51675 10.2363 8.81229 10.4105 9.13315 10.4105H11.1523C11.6615 10.4105 12.0743 9.99769 12.0743 9.48852C12.0743 8.97942 11.6616 8.56668 11.1525 8.56656L9.69947 8.56619L8.65048 6.67082C8.39261 6.2048 7.96665 5.85468 7.45958 5.69178L7.02066 5.55081C6.33548 5.33074 5.58977 5.40455 4.96102 5.75463L2.93622 6.88217Z",
    stroke: "#2E3744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.20117 13.1678L4.85153 11.8181L2.56091 15.8172C2.30635 16.258 2.45742 16.8218 2.89834 17.0764C3.33923 17.3309 3.90303 17.1799 4.15758 16.739L6.20117 13.1678Z",
    stroke: "#2E3744"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1260_18833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.3636,
    height: 17,
    fill: "white",
    transform: "translate(0.316406 0.919678)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPedestrian);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "pedestrian.14912bbb657cb8fbcb7c9eed466b3845.svg";